/**
 * Theme scripts by liquidbook
 *
 */
var $lb = jQuery.noConflict();
$lb(document).ready(function($) {
	var nav_remove_link = [".mobile-divider a", ".no-link a"],
		search_icon = 'fa fa-search';
	// remove link from menu
	remove_menu_link = function(remove_links) {
		var count = remove_links.length;
		for (var i = 0; i < count; i++) {
			$(remove_links[i]).removeAttr("href");
		}
	};
	// remove contents based on array remove_item
	remove_menu_content = function(remove_item) {
		var count = remove_item.length;
		for (var i = 0; i < count; i++) {
			$(remove_item[i] + " span").empty();
		}
	};
	//var close_triggers = ["#searchform .icon_close"];
	// search functions
	close_search_box = function(close_target, close_triggers) {
		$(close_triggers).click(

		function() {
			$(close_target).toggle();
		});
	};
	close_mobile_nav = function(close_target, close_triggers) {
		$(close_triggers).click(

		function() {
			$('.slicknav').slicknav('toggle');
		});
	};
	// open (toggle) search box on click of open trigger
	open_search_box = function(open_target, open_triggers) {
		$(open_triggers).click(
		function() {
			search_focus = open_target + ' input#s';
			//console.log(search_focus);
			$(open_target).toggle();
			$(search_focus).focus();
		});
		
	};
	// global language nave
	open_language_container = function(open_target, open_triggers) {
		$(open_triggers).click(

		function() {
			$(open_target).toggle();
		});
	};
	// looks for search_link selector and replaces with search i tag
	set_search_icon_menu = function(search_link) {
		$(search_link).empty();
		$(search_link).append('<i class="' + search_icon + '"></i>');
	};
	// hide items passed in array hidden_items 
	var hidden_items = ["#searchform", ".mobilesearchform"];
	set_hidden_items = function(hidden_items) {
		var count = hidden_items.length;
		for (var i = 0; i < count; i++) {
			$(hidden_items[i]).hide();
		}
	};
	// returns a specific url parameter
	getQueryVariable = function(variable) {
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			if (pair[0] == variable) {
				return pair[1];
			}
		}
		return (false);
	};
	// set the active tab
	set_active_tab = function(tab_trigger, tab_target) {
		$(tab_trigger).click(

		function() {
			var data_link = $(this).data('sectionLink');
			$(tab_trigger).removeClass('active');
			$(tab_target).removeClass('active');
			$(this).addClass('active');
			$(tab_target + '.' + data_link).addClass('active');
			console.debug(this);
			console.debug(tab_target + '.' + data_link);
		});
	};
	// set the search input field if parameter set
	set_search_box_contents = function(input_field) {
		query = getQueryVariable('s');
		if (query) {
			search_values = query.replace(/\+/g, " ");
			$(input_field).val(search_values);
		}
	}; /* ----- visual composer------- */
	// looks for streched vc row adds class to row
	vc_full_width_add_class = function(data_name, class_name) {
		$('*[' + data_name + '="true"]').addClass(class_name);
	}; /* --------- Mega Menu ------------- */
	var mega_menu_target = $('#site-navigation .menu-item-object-mega_menu');
	var mega_menu_holder = $('.mega-menu-holder');
	/* ----- IE tests ------- */
	// test ie 10
	function ifIE10() {
		ieTest = false;
		if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
			ieTest = true;
		}
		return ieTest;
	}
	// test ie 10
	function ifIE11() {
		ieTest = false;
		var UAString = navigator.userAgent;
		if (UAString.indexOf("Trident") !== -1 && UAString.indexOf("rv:11") !== -1) {
			ieTest = true;
		}
		return ieTest;
	}
	// converts the url to an array
	var getLinkArray = function(href) {
			var link = document.createElement('a');
			link.href = href;
			return link;
		};
	// gets the id from the path
	var getLinkID = function(link, index) {
			var linkPath, pathArray;
			linkPath = link.pathname;
			pathArray = linkPath.split("/");
			if (ifIE11() || ifIE10()) {
				return pathArray[1];
			} else {
				return pathArray[2];
			}
		};
	var getMegaMenuWrapper = function(contents, id) {
			var output = '<div id="MMID-' + id + '" class="mega-menu-contents">';
			output += contents;
			output += '</div>';
			return output;
		};
	// This function looks for mega-menu id in the navigation
	// Then it searchs for a matching mega-menu-container
	// Then places contents in the main menu
	var getMegaMenuItems = function(target, source) {
			$(target).each(function(index) {
				var url = $(this).find('a').attr('href');
				var link = getLinkArray(url);
				var mmID = getLinkID(link);
				var holderID = ".MMID-" + mmID;
				var MegaMenuContents = source.find(holderID).html();
				var MegaMenuWrapper = getMegaMenuWrapper(MegaMenuContents, mmID);
				$(this).empty();
				$(MegaMenuWrapper).appendTo(this);
			});
		};
	var setBackToTop = function() {
			// browser window scroll (in pixels) after which the "back to top" link is shown
			var btt_offset = 1000;
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			var btt_offset_opacity = 1800;
			//duration of the top scrolling animation (in ms)
			var btt_scroll_top_duration = 700;
			//grab the "back to top" link
			var back_to_top = $('.cd-top');
			//hide or show the "back to top" link
			$(window).scroll(function() {
				var toTopAction = ($(this).scrollTop() > btt_offset) ? back_to_top.addClass('cd-is-visible') : back_to_top.removeClass('cd-is-visible cd-fade-out');
				if ($(this).scrollTop() > btt_offset_opacity) {
					back_to_top.addClass('cd-fade-out');
				}
			});
			back_to_top.on('click', function(event) {
				event.preventDefault();
				$('body,html').animate({
					scrollTop: 0
				}, btt_scroll_top_duration);
			});
		};
	var setStickyHeader = function() {
			$(window).scroll(function() {
				var navWrap = $('.site-main-header');
				var navBlockHeight = navWrap.height();
				var navPageTop = $(document).scrollTop();
				var bodyTopPadding = 100;
				var backToTop = $('.lb-back-to-top');
				var lbNav = {
					navSticky: function() {
						navWrap.addClass('sticky');
						backToTop.fadeIn();
					},
					navUnSticky: function() {
						navWrap.removeClass('sticky');
						backToTop.hide();
					}
				}; // lbNav
				/* -- page sticky nav triggers-- */
				if (navPageTop > navBlockHeight + 100) {
					if (!navWrap.hasClass('sticky')) {
						lbNav.navSticky();
					}
				} else {
					if (navWrap.hasClass('sticky')) {
						lbNav.navUnSticky();
					}
				} // end if height test 
			}); // end scroll test
		}; // end setStickyHeader
	var noAnchorLinkEvent = function(linkclass) {
			$(linkclass).click(function(ev) {
				ev.preventDefault();
			});
		};
	// load-more button	
	// initialize js functions
	remove_menu_link(nav_remove_link);
	remove_menu_content(nav_remove_link);
	close_search_box('#searchform', '#searchform .icon_close');
	close_search_box('.mobilesearchform', '.mobilesearchform .icon_close');
	close_mobile_nav('.slicknav', '.slicknav_search_icon a');
	set_search_icon_menu('.search_menu_icon a span');
	open_search_box('#searchform', '.lb_search_menu_btn');
	open_search_box('.mobilesearchform', '.slicknav_search_icon a');
	open_language_container('.site-top-languages', '.language-picker a');
	set_hidden_items(hidden_items);
	set_search_box_contents('#s');
	vc_full_width_add_class('data-vc-full-width', 'lb-vc-full-width');
	getMegaMenuItems(mega_menu_target, mega_menu_holder);
	setBackToTop();
	setStickyHeader();
	set_active_tab('.configure-left .configure', '.configure-right .configure-info');
	noAnchorLinkEvent('jslink a');
	noAnchorLinkEvent('a.jslink ');
});
